var map = {
	"./google-laurel-da-DK.svg": 6886,
	"./google-laurel-de-DE.svg": 33940,
	"./google-laurel-en-GB.svg": 5742,
	"./google-laurel-en-US.svg": 6985,
	"./google-laurel-es-ES.svg": 39814,
	"./google-laurel-es-MX.svg": 32789,
	"./google-laurel-fr-FR.svg": 89034,
	"./google-laurel-it-IT.svg": 55884,
	"./google-laurel-nb-NO.svg": 86879,
	"./google-laurel-nl-NL.svg": 77090,
	"./google-laurel-pl-PL.svg": 7046,
	"./google-laurel-pt-BR.svg": 99966,
	"./google-laurel-pt-PT.svg": 50854,
	"./google-laurel-sv-SE.svg": 60375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94723;